import { Inject, Injectable, Optional, Provider, SkipSelf } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import zhCN from './languages/zh-CN';
import { LXLIB_LOCALE } from './locale.tokens';
import { FullLocaleData, LocaleData } from './locale.types';

@Injectable()
export class LxlibLocaleService {
  private _locale: FullLocaleData;
  private change$ = new BehaviorSubject<FullLocaleData>(this._locale);

  constructor(@Inject(LXLIB_LOCALE) locale: FullLocaleData | null) {
    this.setLocale(locale || zhCN);
  }

  get change(): Observable<FullLocaleData> {
    return this.change$.asObservable();
  }

  setLocale(locale: FullLocaleData): void {
    if (this._locale && this._locale.abbr === locale.abbr) {
      return;
    }
    this._locale = locale;
    this.change$.next(locale);
  }

  get locale(): FullLocaleData {
    return this._locale;
  }

  getData(path: keyof FullLocaleData): LocaleData {
    return (this._locale[path] || {}) as LocaleData;
  }
}

export function LXLIB_LOCALE_SERVICE_PROVIDER_FACTORY(exist: LxlibLocaleService, locale: FullLocaleData): LxlibLocaleService {
  return exist || new LxlibLocaleService(locale);
}

export const LXLIB_LOCALE_SERVICE_PROVIDER: Provider = {
  provide: LxlibLocaleService,
  useFactory: LXLIB_LOCALE_SERVICE_PROVIDER_FACTORY,
  deps: [[new Optional(), new SkipSelf(), LxlibLocaleService], LXLIB_LOCALE],
};
